import { render, staticRenderFns } from "./numberSelector.vue?vue&type=template&id=64f7e8e1&scoped=true"
import script from "./numberSelector.vue?vue&type=script&lang=js"
export * from "./numberSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f7e8e1",
  null
  
)

export default component.exports